@if (task) {
  <div class="caller-details">
    <div class="caller-name-row">
      <div class="caller-avatar">
        <i [nimbusIcon]="ICONS.USER_LIGHT" [iconWeight]="IconWeight.Regular"></i>
      </div>
      <span class="caller-name">
        {{ task.caller?.displayName || task.caller?.phoneNumber }}
        <nimbus-tooltip [text]="task.caller?.displayName || task.caller?.phoneNumber" [position]="'bottom'"></nimbus-tooltip>
      </span>
    </div>
    <div class="caller-status">
      <i [nimbusIcon]="modalityIcon" [iconWeight]="IconWeight.Regular" class="modality-icon"></i>
      <span class="status-state">{{ statusText | translate }}</span>
      @if (task.isDirectCall) {
        <span class="status-state">{{ TranslationKeys.AssistantTaskFooterDirectCall | translate }}</span>
      } @else if (showTime && task.since) {
        <span class="status-state">
          {{ task.since | dateDifference: (currentMoment$ | async) | durationFormat: 'time-in-state' }}
        </span>
      }
    </div>
  </div>
}
